
  import Vue from 'vue'

  export default Vue.extend({
    name: 'NotFound',
    created() {
      document.title = this.$vuetify.lang.t("$vuetify.tab_titles.not_found")
    }
  })
